import { render, staticRenderFns } from "./InventoryChannels.vue?vue&type=template&id=51123f0a"
import script from "./InventoryChannels.vue?vue&type=script&lang=js"
export * from "./InventoryChannels.vue?vue&type=script&lang=js"
import style0 from "./InventoryChannels.vue?vue&type=style&index=0&id=51123f0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports